import N8nAvatar from './Avatar.vue';

export { AVATAR_SIZES, type AvatarSize } from './avatarSizes';
export default N8nAvatar;
